module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Free Hosted Gallery */
(function(fox) {
	'use strict';
	fox.registerWidget('Layout_FreeHostedGallery', {}, 'Site_Layout');
	
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/layout/freeHostedGallery.js
// module id = 872
// module chunks = 4